export const PHONE = "+91 78509 11096";
export const PHONE_LINK = "tel:+917850911096";
export const WHATSAPP_LINK =
  "https://wa.me/917850911096?text=Hi%20Sanvalio%20Academy%2C%20I%20want%20to%20know%20more%20about%20your%20courses.";
export const INSTAGRAM_LINK = "https://www.instagram.com/sanvalio/";
export const INSTAGRAM2_LINK = "https://www.instagram.com/designn_4_you";
export const LINKEDIN_LINK = "https://www.linkedin.com/in/deepankshi-saxena/";
export const FACEBOOK_LINK = "https://www.facebook.com/profile.php?id=61593807128453";

export const FOUNDER_PHOTOS = [
  "/founder/deepankshi-1.jpg",
  "/founder/deepankshi-2.jpg",
  "/founder/deepankshi-3.jpg",
  "/founder/deepankshi-4.jpg",
  "/founder/deepankshi-5.jpg",
];

export const SISTER_BRANDS = [
  { name: "Design4You", url: "https://www.design4you.co.in" },
  { name: "Sanvalio Studio", url: "https://www.sanvalio.com" },
  { name: "Sanvalio India", url: "https://www.sanvalio.in" },
];

export const MARQUEE_ITEMS = [
  "Live Google Meet Classes",
  "Certificate & Diploma Programs",
  "Free Freelancing Mastery for Every Student",
  "Meta Ads Funnel Mastery",
  "Mentoring Since 2015",
  "Career Counselling — Free",
  "India & Global Client Training",
];

export const AUDIENCES = [
  {
    id: "student",
    num: "01",
    title: "Students & Professionals",
    focus:
      "Job-ready skills with certificates & diplomas, metro-city salary paths, and free freelancing training included with every program.",
    picks: ["digital-marketing", "web-design", "brand-design"],
  },
  {
    id: "coach",
    num: "02",
    title: "Coaches, Astrologers & Healers",
    focus:
      "Build a magnetic personal brand, fill your calendar with clients, and sell through high-converting landing pages and Meta ads.",
    picks: ["personal-branding", "meta-ads"],
  },
  {
    id: "business",
    num: "03",
    title: "Business & Brand Owners",
    focus:
      "Our bestseller — master Meta ads, funnels and performance marketing to scale your own brand in-house, agency-level, without agency fees.",
    picks: ["meta-ads", "performance-marketing", "digital-marketing"],
  },
  {
    id: "freelancer",
    num: "04",
    title: "Freelancers & Consultants",
    focus:
      "Win clients in India and overseas, price high-ticket, and turn one skill into a full-time income — from launchpad to global retainers.",
    picks: ["freelancing-launchpad", "web-design", "meta-ads"],
  },
];

export const QUIZ = [
  {
    id: "q1",
    question: "Who best describes you right now?",
    options: [
      { id: "q1_student", label: "Student or working professional" },
      { id: "q1_business", label: "Business / brand owner" },
      { id: "q1_coach", label: "Coach, astrologer, healer or consultant" },
      { id: "q1_freelancer", label: "Freelancer (or want to start)" },
    ],
  },
  {
    id: "q2",
    question: "What is your number one goal?",
    options: [
      { id: "q2_job", label: "A high-paying job in a metro city" },
      { id: "q2_scale", label: "Scale my business with ads & funnels" },
      { id: "q2_brand", label: "Build my personal brand & attract clients" },
      { id: "q2_freedom", label: "Earn freely through freelancing" },
    ],
  },
  {
    id: "q3",
    question: "Which skill excites you the most?",
    options: [
      { id: "q3_ads", label: "Running ads & scaling sales" },
      { id: "q3_marketing", label: "Complete digital marketing" },
      { id: "q3_web", label: "Websites & UI/UX design" },
      { id: "q3_design", label: "Graphics & brand identity" },
    ],
  },
  {
    id: "q4",
    question: "How much time can you commit weekly?",
    options: [
      { id: "q4_light", label: "3–5 hours (alongside studies/job)" },
      { id: "q4_medium", label: "6–10 hours (serious upskilling)" },
      { id: "q4_full", label: "10+ hours (all in, fast track)" },
    ],
  },
  {
    id: "q5",
    question: "What matters more to you?",
    options: [
      { id: "q5_cert", label: "A quick certificate & skill" },
      { id: "q5_diploma", label: "An in-depth diploma with mentorship" },
    ],
  },
];

export const TESTIMONIALS = [
  {
    quote:
      "I joined as a confused student and left running Meta ads for three clients. The batch calls felt like family — Deepankshi ma'am reviews every campaign herself.",
    name: "Simran Kaur",
    role: "Performance Marketer, Mohali",
    initials: "SK",
  },
  {
    quote:
      "As an astrologer I had zero marketing sense. The personal branding course rebuilt my Instagram and my landing page now books 15+ consultations a week.",
    name: "Rahul Sharma",
    role: "Astrologer & Coach, Jaipur",
    initials: "RS",
  },
  {
    quote:
      "We were paying an agency ₹60k a month. After the funnel mastery diploma, my wife and I run our own ads — better ROAS, full control.",
    name: "Vikram Malhotra",
    role: "D2C Brand Owner, Delhi",
    initials: "VM",
  },
];

export const GALLERY = [
  {
    src: "https://design4you.co.in/founder.jpg",
    caption: "Deepankshi Saxena — Founder & Lead Mentor",
  },
  {
    src: "https://images.unsplash.com/photo-1610716632424-4d45990bcd48?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    caption: "Live strategy workshop — funnels week",
  },
  {
    src: "https://images.unsplash.com/photo-1522202176988-66273c2fd55f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    caption: "Students building live campaign projects",
  },
  {
    src: "https://images.unsplash.com/photo-1531482615713-2afd69097998?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    caption: "Design critique circle — brand identity batch",
  },
  {
    src: "https://images.unsplash.com/photo-1782069326883-090221bfcd6e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    caption: "Where the late-night ad labs happen",
  },
  {
    src: "https://images.unsplash.com/photo-1552664730-d307ca884978?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    caption: "Mentor review — landing page teardowns",
  },
];
